class UFilteredListDateFilter extends Uneet {
  constructor (domElement, toggleCallback, updateCallback) {
    super(domElement)
    this.isOpen = false
    // this Component mantains a list of fake Filter Items, as in, it doesn't really have them,
    // it just works as it did to comply with the common methods of other filters
    this.prevYear = 0
    this.selectedYear = 0
    this.__toggleCallback = toggleCallback
    this.__updateCallback = updateCallback
    this.__init()
  }

  __init () {
    // bind open close
    const toggleBtn = this._e.querySelectorAll('button.toggle-filter-dd')[0]
    toggleBtn.onClick(() => {
      this.toggle()
    })

    // init select 2
    this.$select = jQuery(this._e.querySelectorAll('.u_filtered-list-date-filter--year-dropdown')[0])
    this.$select.select2({
      minimumResultsForSearch: Infinity
    })
    this.$select.on('select2:select', (ev) => {
      this.__onSelect2Change()
    })
  }

  __onSelect2Change () {
    this.prevYear = this.selectedYear
    this.selectedYear = parseInt(this.$select.val())
    if (this.prevYear !== this.selectedYear) {
      this.__updateCallback(this, this.prevYear)
    }
  }

  getDateFilter () {
    return (this.selectedYear === 0) ? null : this.selectedYear
  }

  resetDateFilter () {
    this.$select.val('0').trigger('change')
    this.__onSelect2Change()
  }

  toggle (force = null) {
    const initialValue = this.isOpen
    // force = true: open | force = false: close
    if (force === null) {
      this.isOpen = !this.isOpen
    } else {
      this.isOpen = force
    }
    this._e.toggleClass('isOpen', this.isOpen)

    if (initialValue !== this.isOpen) {
      this.__toggleCallback()
    }
  }
}
